import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
// Types
import mixins from "vue-typed-mixins";
// Enums
import { Modals } from '../../enums/Modals';

// Mixins
import BundleCustomizationModalEvents from './BundleCustomizationModalEvents';

// Components
import { BundleCustomizationModalView } from '../overridableComponents';
const BundleCustomizationModal = mixins(BundleCustomizationModalEvents).extend({
  components: {
    BundleCustomizationModalView
  },
  data() {
    return {
      selectedBundle: {}
    };
  },
  provide() {
    return {
      selectedBundle: this.selectedBundle
    };
  },
  methods: {
    async beforeOpen(props) {
      if (!(props !== null && props !== void 0 && props.params)) return;
      const {
        selectedBundle
      } = props.params;
      Object.assign(this.selectedBundle, selectedBundle || null);
    }
  },
  render() {
    const h = arguments[0];
    return h("modal", _mergeJSXProps([{
      "attrs": {
        "name": Modals.BundleCustomization,
        "id": Modals.BundleCustomization,
        "height": "80%",
        "width": "90%",
        "clickToClose": true
      }
    }, {
      "on": {
        'before-open': this.beforeOpen
      }
    }]), [h(BundleCustomizationModalView, {
      "on": {
        "close": () => {
          this.$modal.hide(Modals.BundleCustomization);
        }
      }
    })]);
  }
});
export default BundleCustomizationModal;